import { useQueries } from '@tanstack/react-query';
import { MockableApi as Api } from '#app/api/mockableApi';
import { QUERY_KEYS } from '#app/constants/queryKeys';
import type { ApiResponse } from '#app/types/api';
import type { RoboadvisorStatusData } from '#app/types/roboStatus';

interface UseRoboadvisorStatusesQueryParams {
  roboIds: Array<number | string | undefined>;
}

const fetchRoboadvisorStatus = async (
  roboId: number | string
): Promise<RoboadvisorStatusData | null> => {
  return new Promise((resolve, reject) => {
    Api.get('integration', 'robo-client-status', { id: roboId })
      .withoutNotify()
      .call(
        (response: ApiResponse<RoboadvisorStatusData | null>) => resolve(response.data ?? null),
        (error: any) => reject(error)
      );
  });
};

export const useRoboadvisorStatusesQuery = ({ roboIds }: UseRoboadvisorStatusesQueryParams) => {
  const statusQueries = useQueries({
    queries: roboIds.map((roboId) => ({
      queryKey: QUERY_KEYS.roboadvisor.status(roboId),
      queryFn: () => fetchRoboadvisorStatus(roboId as number | string),
      enabled: !!roboId,
    })),
  });

  return roboIds.reduce<Record<number | string, RoboadvisorStatusData | null | undefined>>(
    (acc, roboId, index) => {
      if (roboId == null) return acc;
      acc[roboId] = statusQueries[index]?.data;
      return acc;
    },
    {}
  );
};
